module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inner-content"
  }, [_c('div', {
    staticClass: "clearfix shop-top"
  }, [_c('div', {
    staticClass: "m-g-20"
  }, [_c('div', {
    staticClass: "s-info"
  }, [_c('div', {
    staticClass: "f-n"
  }, [_vm._v(_vm._s(_vm.shop.name))]), _vm._v(" "), _c('div', {
    staticClass: "m-g-13"
  }, _vm._l((_vm.shop.labelList), function(la) {
    return _c('span', {
      staticClass: "s-tab f-t text-center"
    }, [_vm._v(_vm._s(la))])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "m-g-46"
  }, [_c('span', {
    staticClass: "f-a"
  }, [_vm._v("商家地址：" + _vm._s(_vm.shop.address))]), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "m-g-10"
  }, [_c('span', {
    staticClass: "f-a s-p"
  }, [_vm._v("商家电话：" + _vm._s(_vm.shop.telephone))])]), _vm._v(" "), _c('div', {
    staticClass: "m-g-10"
  }, [_c('span', {
    staticClass: "f-a s-p"
  }, [_vm._v("商家微信：" + _vm._s(_vm.shop.weixin))])]), _vm._v(" "), _c('div', {
    staticClass: "m-g-10"
  }, [_c('span', {
    staticClass: "f-a s-p"
  }, [_vm._v("商家微博：" + _vm._s(_vm.shop.weibo))])])]), _vm._v(" "), _c('div', {
    staticClass: "img-s-div img-c-div",
    style: ({
      backgroundImage: "url(" + _vm.shop.coverImgUrl + ")"
    })
  })])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix m-g-60 m-b-60"
  }, [_c('div', {
    staticClass: "clearfix s-news"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.poster_list), function(p) {
    return _c('div', {
      staticClass: "m-g-20",
      on: {
        "click": function($event) {
          return _vm.goPosterDetail(p.uuid)
        }
      }
    }, [_c('div', {
      staticClass: "news-info"
    }, [_c('div', {
      staticClass: "f-ar-t clamp"
    }, [_vm._v(_vm._s(p.title))]), _vm._v(" "), _c('div', {
      staticClass: "m-g-10 f-ar-c"
    }, [(p.type !== 4) ? _c('span', {
      staticClass: "clamp"
    }, [_vm._v(_vm._s(p.content[0].text))]) : _vm._e(), _vm._v(" "), (p.type === 4) ? _c('span', {
      staticClass: "clamp"
    }, [_vm._v(_vm._s(p.content.text))]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "img-news-div mg-style",
      style: ({
        backgroundImage: 'url(' + p.cover + ')'
      })
    }), _vm._v(" "), _c('div', {
      staticClass: "line2 m-g-20"
    })])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "clearfix s-detail"
  }, [_c('div', {
    directives: [{
      name: "sticky",
      rawName: "v-sticky",
      value: ({
        zIndex: 12,
        stickyTop: 0
      }),
      expression: "{ zIndex: 12, stickyTop: 0 }"
    }]
  }, [_c('div', {
    staticClass: "s-details-tab"
  }, [_c('span', {
    class: {
      'active': _vm.activeDetailTag === 0
    },
    on: {
      "click": function($event) {
        return _vm.scrollTo('s-profile', 0)
      }
    }
  }, [_vm._v("商家简介")]), _c('span', {
    class: {
      'active': _vm.activeDetailTag === 1
    },
    on: {
      "click": function($event) {
        return _vm.scrollTo('s-discount', 1)
      }
    }
  }, [_vm._v("优惠信息")]), _c('span', {
    class: {
      'active': _vm.activeDetailTag === 2
    },
    on: {
      "click": function($event) {
        return _vm.scrollTo('s-cases', 2)
      }
    }
  }, [_vm._v("商家案例")])])]), _vm._v(" "), _c('div', {
    staticClass: "s-profile p-t-40",
    attrs: {
      "id": "s-profile"
    }
  }, [_c('div', {
    staticClass: "pro-t-1"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "rectangle-3 m-g-20 f-a"
  }, [_c('span', {
    staticClass: "l-h-30 text-prewarp"
  }, [_vm._v(_vm._s(_vm.shop.brief))])]), _vm._v(" "), _c('div', {
    staticClass: "img-pro-div m-g-30 img-c-div",
    style: ({
      backgroundImage: "url(" + _vm.shop.briefImgUrl + ")"
    })
  })])]), _vm._v(" "), _c('div', {
    staticClass: "s-discount p-t-30",
    attrs: {
      "id": "s-discount"
    }
  }, [_c('div', {
    staticClass: "pro-t-1"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "rectangle-3 m-g-20 f-a"
  }, [_c('span', {
    staticClass: "l-h-30 text-prewarp"
  }, [_vm._v(_vm._s(_vm.shop.promotionInfo ? _vm.shop.promotionInfo : '暂无'))])])])]), _vm._v(" "), _c('div', {
    staticClass: "s-cases p-t-30",
    attrs: {
      "id": "s-cases"
    }
  }, [_c('div', {
    staticClass: "pro-t-1"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "rectangle-3 m-g-30"
  }, _vm._l((_vm.case_list), function(c) {
    return _c('div', {
      staticClass: "c-2-1 m-b-md b-gray-1 hp-item-6",
      on: {
        "click": function($event) {
          return _vm.goToCase(c.id)
        }
      }
    }, [_vm._v("\n              " + _vm._s( /** use background for image */ ) + "\n              "), _c('div', {
      staticClass: "clearfix m-a img-c-div h-44",
      style: ({
        backgroundImage: 'url(' + c.coverImgUrl + ')'
      })
    }), _vm._v(" "), _c('div', {
      staticClass: "m-a b-gray-1 p-a h-p-item-c"
    }, [_c('div', {
      staticClass: "m-b-15 text-elli"
    }, [_c('span', {
      staticClass: "f-6"
    }, [_c('span', [_vm._v(_vm._s(_vm.shop.cityName ? _vm.shop.cityName : '北京'))]), _vm._v("｜" + _vm._s(c.title))]), _vm._v(" "), ((_vm.shop && _vm.shop.name) !== null && (_vm.shop && _vm.shop.name) !== undefined) ? _c('span', {
      staticClass: "f-7"
    }, [_vm._v("－" + _vm._s(_vm.shop && _vm.shop.name))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "gray-1 text-small"
    }, [_c('div', {
      staticClass: "text-elli"
    }, [_vm._v(_vm._s(c.description))])])])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "for-more text-center m-g-25"
  }, [_c('span', {
    staticClass: "f-m",
    on: {
      "click": function($event) {
        return _vm.seeMoreCase()
      }
    }
  }, [_vm._v("查看更多")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "banner-r b-c-1"
  }, [_c('span', {
    staticClass: "h-60",
    staticStyle: {
      "font-size": "18px",
      "color": "#252525"
    }
  }, [_vm._v("商家资讯")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title1"
  }, [_c('span', {
    staticClass: "f-title"
  }, [_vm._v("商家简介")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title1"
  }, [_c('span', {
    staticClass: "f-title"
  }, [_vm._v("优惠信息")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title1"
  }, [_c('span', {
    staticClass: "f-title"
  }, [_vm._v("商家案例")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-88d0f190"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ShopDetail.vue
// module id = 609
// module chunks = 1